import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DashboardTile.css';

const DashboardTile = ({ title, icon, description, path, color = '#4285F4', disabled = false, badge }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!disabled && path) navigate(path);
  };

  return (
    <div
      className={`dashboard-tile${disabled ? ' dashboard-tile--disabled' : ''}`}
      onClick={handleClick}
      role={disabled ? undefined : 'button'}
      tabIndex={disabled ? undefined : 0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      style={{ borderTopColor: color }}
    >
      <div className="dashboard-tile__icon" style={{ backgroundColor: color }}>
        {icon}
      </div>
      <div className="dashboard-tile__body">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      {badge != null && <span className="dashboard-tile__badge">{badge}</span>}
      {disabled && <span className="dashboard-tile__coming-soon">Coming Soon</span>}
    </div>
  );
};

export default DashboardTile;
